import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-rewards-success-fail-message',
  templateUrl: './rewards-success-fail-message.component.html',
  styleUrls: ['./rewards-success-fail-message.component.scss'],
})
export class RewardsSuccessFailMessageComponent  implements OnInit {


  @Output() onClickCurrentStatus: EventEmitter<any> = new EventEmitter();
  @Output() onClickClose: EventEmitter<any> = new EventEmitter();
  @Input('isFailed') isShowError:boolean = false;
  @Input('successMessage') successMessage:string = "Your points redemption was successful.";
  @Input('successMessage2') successMessage2:string = "Thanks for your loyalty and enjoy playing!";
  @Input('errorMessage') errorMessage:string = "Your points redemption was unsuccessful.";
  @Input('errorMessage2') errorMessage2:string = "";
  @Input('buttonText') buttonText:string = "Current Status";
  @Input('enableCloseBtn') enableCloseBtn:boolean = true;

  constructor() { }

  ngOnInit() {}

  goToFirstPage(isClose){
    if(isClose){
      this.onClickClose.emit();
      return;
    }
    this.onClickCurrentStatus.emit();
  }

}
